// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3KqIs","upload":"Small_upload__3pFzP","imageWrap":"Small_imageWrap__VTZXX","removeBtn":"Small_removeBtn__2Cuvu"};